import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5 12.1575V10.1719H7.55144L10.0693 7.65408L8.6652 6.25L3.75 11.1652L8.6652 16.0804L10.0693 14.6766L7.55144 12.1576L22.5 12.1575Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8501 16.1304H26.2501V18.1167H11.8501V16.1304Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8501 22.0892H26.2501V24.0754H11.8501V22.0892Z",
			fill: "currentColor"
		})
	]
});
export default SvgMenuClose;
